import React, { useCallback, useState } from 'react'
import Footer from './components/Footer.js'
import Gallery from './components/Gallery/index.js'
import Lightbox from './components/Lightbox.js'
import photos from './photos.js'

import { lazyLoad } from './utils.js'

const filteredPhotos = photos

function App() {
  const [currentPhoto, setCurrentPhoto] = useState(0)
  const [viewerIsOpen, setViewerIsOpen] = useState(false)

  const openLightbox = useCallback((event, { photo, index }) => {
    setCurrentPhoto(index)
    setViewerIsOpen(true)
  }, [])

  const closeLightbox = useCallback(() => {
    setCurrentPhoto(0)
    setViewerIsOpen(false)
  }, [])

  return (
    <>
      <Gallery
        photos={filteredPhotos}
        onLoad={lazyLoad}
        onClick={openLightbox}
      />
      <Lightbox
        photos={filteredPhotos}
        viewerIsOpen={viewerIsOpen}
        currentPhoto={currentPhoto}
        closeLightbox={closeLightbox}
      />
      <Footer />
    </>
  )
}

export default App
